<template>
  <article id="sobre">
    <Letreiro title="Sobre" class="blend" :style="'background-image: url(' + require('../assets/extras/bush.jpg') + ')'" />
    <section>
      <svg viewBox="0 0 337.4 175.6">
       <path d="M201.3,103.5c0,1.9,1.4,23.1-19.7,23.1c-15.3,0-19.1-11.5-19.6-16.8h9.4c0.4,2,1.7,8.4,10.3,8.4c12.1,0,10.3-12.9,10.3-18.3 c-5.3,6.6-18.3,8.5-26.4-0.3c-7.8-8.4-6.3-23.6-0.4-30.3c9.9-11,24.6-6.2,26.8-2.1v-3.4h9.4V103.5z M180.9,71.2 c-15,0-14.9,26.1,0,26.1C195.9,97.3,196.3,71.2,180.9,71.2z"/>
       <path d="M213.1,63.9h9.4v2.4c1.7-1.8,9.4-6.2,17.2-1.1l-3.1,8.6c-9.8-5.1-14.1,0.5-14.1,9.7v21h-9.4V63.9z"/>
       <path d="M274.9,63.9v3.5c-6.8-8.8-31.8-6.6-31.8,16.7c0,22.2,22.6,25.9,31.8,17.4v3h9.4V63.9H274.9z M263.8,97.3 c-14.9,0-15.2-26,0.1-26C279.4,71.2,279.5,97.3,263.8,97.3z"/>
       <path d="M315.8,62.8c28.6,0,29,42.8-0.2,42.8C287.2,105.6,286.9,62.8,315.8,62.8z M315.8,97.3c16.1,0,16.3-26,0-26 C300,71.2,299.5,97.3,315.8,97.3z"/>
       <path d="M257.3,56.9l-5.5-4.6c3.4-4.9,5.7-7.7,10.6-7.7c5.3,0,10.7,4.4,13.1,4.4c1.6,0,3.3-1.5,5.2-4.5l5.3,4.4 c-2.7,5.3-6.3,8-10.8,8C267.1,56.8,261.9,47.3,257.3,56.9z"/>
       <path d="M0,87.5c0,33.6,22.2,61.7,55.2,70.2c0.3-4.9,0.8-9.1,1.5-13c-26.9-8.1-42.3-28.9-42.3-57.2c0-20.7,7.4-36.5,25.9-50.9 c7.5-5.8,14.5-11.5,15.8-20.8C23.1,24,0,53.4,0,87.5z"/>
       <path d="M81.2,0c-7.7,0.9-13,7.2-13.9,16.7c-1.5,15.5-12.4,23.7-15.2,25.6C34.7,54.1,25.2,67.3,25.2,87.1 c0,21.8,14.5,41.3,35.3,47.4c2.2-5.6,4.8-9.1,6.6-11c0-0.1,0.1-0.1,0.1-0.2C41.7,116.8,39.7,94,39.7,87.1c0-8.7,5.3-19.9,17.1-28.5 C74.4,45.8,81.2,37.5,81.2,0z"/>
       <path d="M147.8,87c0-33.3-24-63.8-55.8-71.1c-0.3,5-0.8,9.4-1.6,13.4c26.4,10,43.6,34.5,43.6,57.7c0,19-7.2,33.3-23.9,45.8 c-11.9,8.9-15.9,14.9-16.8,24.7C112.4,154.7,147.8,128.5,147.8,87z"/>
       <path d="M104.4,124c12.7-9.8,19.1-21.2,19.1-37.1c0-19.7-15.9-40.5-36.3-47.6c-3,7.6-7.7,12.4-7.7,12.5C97,57.9,107.8,71.3,107.8,87 c0,7.6-3.4,19.6-16.2,28.8c-22.4,16.1-25.6,22-25.6,59.6c5.3,0.5,9.9,0.5,15.2,0.1C81.2,143.3,85.4,138.8,104.4,124z"/>
      </svg>
      <p>Com suas raízes na película cinematográfica, a <b>Grão</b> nasce com forte acento de brasilidade, referenciando também ícones de nossa cultura, como praias e cafezais.</p>
      <p>Atualmente, a <b>Grão</b> produz conteúdos culturais críticos e inovadores, desenvolvendo tecnologias e almejando o impacto social.</p>
      <p>Nossa especialidade é construir pontes entre novas possibilidades formais propiciadas pelas mídias digitais e as necessidades de conteúdos de nossos parceiros.</p>
    </section>
  </article>
</template>

<script>
import Letreiro from '@/components/Letreiro.vue'

export default {
  name: 'Sobre',
  components: {
    Letreiro
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 section svg { width: auto; height: 20%; margin: auto;}

 /* --- LETREIRO --- */
    .triggerSobre h1 >>> span {
      animation-name: letreiro;
      animation-duration: 1s;
      animation-direction: reverse;
      animation-fill-mode: both;
      opacity: 0;
    }
   /* SOBRE */
     h1 >>> span:nth-child(1) { /* S */
     	grid-column: 7;
     	grid-row: 1;
     	animation-delay: 0.4s;
     }
     h1 >>> span:nth-child(2) { /* o */
     	grid-column: 8;
     	grid-row: 3;
     	animation-delay: 0.3s;
     }
     h1 >>> span:nth-child(3) { /* b */
     	grid-column: 1;
     	grid-row: 5;
     	animation-delay: 0.2s;
     }
     h1 >>> span:nth-child(4) { /* r */
     	grid-column: 8;
     	grid-row: 7;
     	animation-delay: 0.1s;
     }
     h1 >>> span:nth-child(5) { /* e */
     	grid-column: 3;
     	grid-row: 8;
     	animation-delay: 0s;
     }

@media (min-width: 768px) {
 /*
   ##Device = Tablets, Ipads
   ##Screen = B/w 768px to 1024px
 */


 /* SOBRE */
   h1 >>> span:nth-child(1) { /* S */
    grid-column: 2;
    grid-row: 3;
   }
   h1 >>> span:nth-child(2) { /* o */
    grid-column: 3;
    grid-row: 3;
   }
   h1 >>> span:nth-child(3) { /* b */
    grid-column: 6;
    grid-row: 5;
  }
}
</style>
